import ConsentDefaults from 'constants/consentDefaults'

import CookieConsents from 'utils/cookieConsents'

import consentAllForScanner from './consentAllForScanner'


/**
 * @param {object} args
 * @param {number} args.cookiePolicyVersion
 */
export default function makeConsentAll({ cookiePolicyVersion }) {
  /**
   * @name consentAll
   *
   * @param {object} [args]
   * @param {number} args.isPersistent - stores consents in browser when true
   */
  return async ({ isPersistent } = {}) => {
    await consentAllForScanner()

    if ( isPersistent ) {
      CookieConsents.setConsents({
        ...ConsentDefaults.OPT_OUT,
        document_version_id: cookiePolicyVersion,
      })
    }
  }
}
